import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container'];

  call(_event) {
    if (this.hasContainerTarget) this.containerTarget.classList.add('hidden');
  }
}
